import { getActionName } from "../helpers/utils";

const initialStateForAction = {
  isRequesting: false,
  isSuccess: false,
  errors: undefined,
};

const initialState = {
  ["GET_DOCUMENTS_LIST"]: initialStateForAction,
  ["GET_DEAL"]: initialStateForAction,
  ["GET_DEALS_LIST"]: initialStateForAction,
  ["GET_CLIENTS_LIST"]: initialStateForAction,
  ["REMOVE_CLIENT"]: initialStateForAction,
  ["CLIENT_CREATE"]: initialStateForAction,
  ["GET_SECTIONS"]: initialStateForAction,
  ["GET_FIELDS"]: initialStateForAction,
  ["COPY_VARIABLES"]: initialStateForAction,
  ["GET_CLIENTS_FIELDSET"]: initialStateForAction,
  ["CREATE_FIELD"]: initialStateForAction,
  ["DEAL_COMPANY_MEMBER_UPDATE"]: initialStateForAction,
};

export default function actionStatusReducer(state = initialState, action) {
  const { type } = action;
  const actionName = getActionName(type);
  const actionType = type.endsWith("_REQUEST")
    ? "request"
    : type.endsWith("_SUCCESS")
    ? "success"
    : type.endsWith("_FAIL")
    ? "fail"
    : undefined;

  switch (actionType) {
    case "request":
      return {
        ...state,
        [actionName]: {
          isRequesting: true,
          isSuccess: false,
          errors: undefined,
        },
      };
    case "success":
      return {
        ...state,
        [actionName]: {
          isRequesting: false,
          isSuccess: true,
          errors: undefined,
        },
      };
    case "fail":
      return {
        ...state,
        [actionName]: {
          isRequesting: false,
          isSuccess: false,
          errors: action.error || undefined,
        },
      };
    default:
      return { ...state };
  }
}
